// Code for Widget
jQuery(function(){

	var $select_make = jQuery('select[name="make"]');
    var $select_year = jQuery('select[name="year"]');
    var $select_model = jQuery('select[name="model"]');
    var $select_engine = jQuery('select[name="engine"]');

    var $select_mobile_make = jQuery('select[name="mobile_make"]');
    var $select_mobile_year = jQuery('select[name="mobile_year"]');
    var $select_mobile_model = jQuery('select[name="mobile_model"]');
    var $select_mobile_engine = jQuery('select[name="mobile_engine"]');

    jQuery('body').on('change', 'select[name="make"]', function(){
        var get = { };
        get.make = $select_make.val();
        $select_mobile_make.val(get.make);

        jQuery.get('/api/car_models', get, function(response){
            $select_model.empty().append(response);
            $select_mobile_model.empty().append(response);
            $select_model.removeAttr('disabled');
            $select_engine.empty();
            $select_mobile_engine.empty();
            $select_mobile_model.removeAttr('disabled');
        });

    });

    jQuery('body').on('change', 'select[name="mobile_make"]', function(){
        var get = { };
        get.make = $select_mobile_make.val();
        $select_make.val(get.make);

        jQuery.get('/api/car_models', get, function(response){
            $select_model.empty().append(response);
            $select_mobile_model.empty().append(response);
            $select_model.removeAttr('disabled');
            $select_mobile_model.removeAttr('disabled');
        });

    });


    jQuery('body').on('change', 'select[name="model"]', function(){
        var get = { };
        get.model = $select_model.val();
        $select_mobile_model.val(get.model);

        jQuery.get('/api/car_engines', get, function(response){
            $select_engine.empty().append(response);
            $select_mobile_engine.empty().append(response);
            $select_year.removeAttr('disabled');
            $select_mobile_year.removeAttr('disabled');
        });
    });

    jQuery('body').on('change', 'select[name="mobile_model"]', function(){
        var get = { };
        get.model = $select_mobile_model.val();
        $select_model.val(get.model);

        jQuery.get('/api/car_engines', get, function(response){
            $select_engine.empty().append(response);
            $select_mobile_engine.empty().append(response);
            $select_year.removeAttr('disabled');
            $select_mobile_year.removeAttr('disabled');
        });
    });


    jQuery('body').on('change', 'select[name="year"]', function(){
        $select_mobile_year.val(jQuery(this).val());
        $select_engine.removeAttr('disabled');
        $select_mobile_engine.removeAttr('disabled');
	});

    jQuery('body').on('change', 'select[name="mobile_year"]', function(){
        $select_year.val(jQuery(this).val());
        $select_engine.removeAttr('disabled');
        $select_mobile_engine.removeAttr('disabled');
	});


    jQuery('body').on('change', 'select[name="engine"]', function(){
        $select_mobile_engine.val(jQuery(this).val());
        jQuery('.battery-form__button').removeClass('button--disabled');
    });

    jQuery('body').on('change', 'select[name="mobile_engine"]', function(){
        $select_engine.val(jQuery(this).val());
        jQuery('.battery-form__button').removeClass('button--disabled');
    });

    jQuery('body').on('submit', '.battery-widget__form', function(e){
        e.preventDefault();

        if(!jQuery('.battery-form__button').hasClass('button--disabled')) {
            jQuery('.battery-widget__form-error').addClass('battery-widget__form-error--hidden');
            jQuery('.battery-widget__form').addClass('battery-widget__form--hidden');
            jQuery('.battery-widget__results--hidden').removeClass('battery-widget__results--hidden');

            var vehicle = jQuery('select[name="year"]').val() + " " + jQuery('select[name="make"]').val() + " " + jQuery('select[name="model"]').val();
            jQuery('.battery-widget__vehicle').html(vehicle);

            jQuery('.battery-widget__engine').html(jQuery('select[name="engine"]').val());
        } else {
            jQuery('.battery-widget__form-error--hidden').removeClass('battery-widget__form-error--hidden');
        }

        return false;
    });


    jQuery('body').on('click', '.battery-widget__link--restart', function(e){
        e.preventDefault();

        jQuery('.battery-widget__form-error').addClass('battery-widget__form-error--hidden');
        jQuery('.battery-widget__results').addClass('battery-widget__results--hidden');
        jQuery('select[name="engine"]').html('').prop('disabled', true);
        jQuery('select[name="mobile_engine"]').html('').prop('disabled', true);
        jQuery('select[name="year"]').prop('selectedIndex', 0);
        jQuery('select[name="mobile_year"]').prop('selectedIndex', 0);
        jQuery('select[name="model"]').html('').prop('disabled', true);
        jQuery('select[name="mobile_model"]').html('').prop('disabled', true);
        jQuery('select[name="make"]').prop('selectedIndex', 0);
        jQuery('select[name="mobile_make"]').prop('selectedIndex', 0);
        jQuery('.battery-form__button').addClass('button--disabled');
        jQuery('.battery-widget__form').removeClass('battery-widget__form--hidden');

        return false;
    });

});
